export const GET_SHOWCASE_COMMENT_COUNTERS = 'GET_SHOWCASE_COMMENT_COUNTERS'
export const GET_SHOWCASE_COMMENT_COUNTERS_REQUEST = 'GET_SHOWCASE_COMMENT_COUNTERS_REQUEST'
export const GET_SHOWCASE_COMMENT_COUNTERS_SUCCESS = 'GET_SHOWCASE_COMMENT_COUNTERS_SUCCESS'
export const GET_SHOWCASE_COMMENT_COUNTERS_ERROR = 'GET_SHOWCASE_COMMENT_COUNTERS_ERROR'
